import { render, staticRenderFns } from "./kw_relation_graph.vue?vue&type=template&id=d96cd77e&scoped=true&"
import script from "./kw_relation_graph.vue?vue&type=script&lang=js&"
export * from "./kw_relation_graph.vue?vue&type=script&lang=js&"
import style0 from "./kw_relation_graph.vue?vue&type=style&index=0&id=d96cd77e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96cd77e",
  null
  
)

component.options.__file = "kw_relation_graph.vue"
export default component.exports